import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { ImageGamingJoy, ImageGamingRoom, ImageMobile, ImageProgramming } from '../../../assets/images';
import '../styles.scss';

function FeaturedCarousel({ item = [] }) {
  return item[0] ? (
    <div id="FeaturedCarousel">
      {item.map(item => (
        <CardCarouselImage image={item.image} link={item.link} />
      ))}
    </div>
  ) : null
}

const CardCarouselImage = ({ image, link = '#' }) => {
  return (
    <a href={link} className="featured-carousel-image">
      <img src={image} alt="img-carousel" effect="blur" />
    </a>
  )
}

export default FeaturedCarousel;
